__webpack_require__.p = "/e-commerce/";